import React from 'react';

import join from 'url-join';

import { PageURL } from '@app/core/widgets/pages';

import { FieldDetails } from '@app/widgets/contacts-and-settings/components/FieldDetails';
import { FieldsList } from '@app/widgets/contacts-and-settings/components/FieldsList';

export interface RouteItem {
  readonly key: string;
  readonly path: string;
  readonly component: React.FC;
}

export const getSettingsRoutes = (sections: string): Array<RouteItem> => [{
  // eslint-disable-next-line i18next/no-literal-string
  key: 'fields-list',
  path: join(PageURL.CONTACTS_AND_SETTINGS, `:sectionId(${sections})`),
  component: FieldsList,
}, {
  // eslint-disable-next-line i18next/no-literal-string
  key: 'field-details',
  // eslint-disable-next-line i18next/no-literal-string
  path: join(PageURL.CONTACTS_AND_SETTINGS, `:sectionId(${sections})`, ':fieldId'),
  component: FieldDetails,
}];
